// extracted by mini-css-extract-plugin
export default {"image":"hY-z","loaded":"iY-z"};